import React, { FC, useState } from 'react';
import { CancelIcon } from '../../../assets/icons';
import Button from '../Button';

type ErrorModalProps = {
    errorMsg?: string | null | undefined;
    showModal?: boolean;
    setShowModal?: (value: boolean) => void;
};
const ErrorModal: FC<ErrorModalProps> = ({ showModal, setShowModal, errorMsg }) => {
    const [isOpenModal, setIsOpenModal] = useState<Boolean | null | undefined>(showModal)
    return (
        <React.Fragment>
            {(setShowModal ? showModal : isOpenModal) ? (
                <>
                    <div className='m-10 justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
                        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
                            {/*content*/}
                            <div className='px-3 border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none'>

                                {/*header*/}
                                <div className='py-3 flex items-center justify-between border-solid border-blueGray-200 rounded-t'>
                                    <h3 className='text-lg font-semibold'>Error</h3>
                                    <div className='cursor-pointer !-mr-2' onClick={() => { setShowModal?.(false); setIsOpenModal?.(false) }}>
                                        <CancelIcon className='!h-4 !w-4' />
                                    </div>
                                </div>

                                {/*body*/}
                                <div className='relative flex-auto max-h-40 overflow-auto'>
                                    <p className='text-blueGray-500 text-base leading-relaxed'>
                                        {errorMsg ? errorMsg : 'Something went wrong! Please try again later.'}
                                    </p>
                                </div>


                                {/*footer*/}
                                <div className='my-3 flex items-center justify-end gap-2 border-solid border-blueGray-200 rounded-b'>
                                    {/* <Button variant='secondary' color='danger' onClick={() => setIsOpenModal?.(false)}>
                                        Close
                                    </Button> */}

                                    <Button variant='primary' color='danger' onClick={() => { setShowModal?.(false); setIsOpenModal?.(false) }}>
                                        Close
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='opacity-25 fixed inset-0 z-40 bg-black'></div>
                </>
            ) : null}
        </React.Fragment>
    );
};

export default ErrorModal;
